/* eslint-disable @typescript-eslint/no-explicit-any */
import { useNavigate } from "react-router-dom";
import React from "react";

export const withNavigate = (Component: any) => {
    const WrappedComponent = (props: any) => {
        const navigate = useNavigate();
        return <Component {...props} navigate={navigate} />;
    };

    // Aggiungi la displayName per evitare l'errore ESLint
    WrappedComponent.displayName = `WithNavigate(${Component.displayName || Component.name || "Component"})`;

    return WrappedComponent;
};

export const withNavigateV2 = (Component: any, state?: any) => {
    const WrappedComponent = (props: any) => {
        const navigate = useNavigate();
        return <Component {...props} navigate={navigate} />;
    };

    // Aggiungi la displayName per evitare l'errore ESLint
    WrappedComponent.displayName = `WithNavigate(${Component.displayName || Component.name || "Component"})`;

    return WrappedComponent;
};
